/**
 * 渠道类型
 */
export enum EnumOrderType {
  Order = 'order',
  Rider = 'waimaiRider',
  WaiMaiShop = 'waimaiShop',
  KeemartRider = 'keemartRider',
}

/**
 * 订单类型
 */
export enum EnumOrderHelpeScene {
  Home = 1,
  ORDER,
  QUEUE
}

/**
 * Faq类型
 */
export enum EnumFaqType {
  // 服务进度
  Progress = 'apply_progress',
  // 问题分类
  CategoryFaq = 'category',
  // 订单问题
  Order = 'order',
}

export interface IOrderButton {
  name: string;
  iconUrl: string;
  rtlIconUrl: string;
  button: {
    type: string;
    url: string;
    phoneNum: string | null;
    faqSearchKey: string | null;
  };
}

export interface IOrderDTO {
  orderType?: EnumOrderType;
  orderTitle: string;
  orderTime: string;
  orderPrice?: string;
  orderImageUrl: string;
  orderDefaultImgUrl?: string;
  orderStatus: string;
  orderId: string;
  orderContentList?: string[];
  orderHelperDTOList?: Array<IOrderButton>;
  extend?: {
    isShowTranslateButton: boolean;
    customerAddressLanguage?: string;
    translateAddress: string;
    orderId?: string; //小象骑手订单-用户交易订单-展示用
  };
  userGetMode: string;

  shopName?: string;
  shopId?: string;
  // 0517 11:00 新增订单序列号，用于B端移动端
  orderSeqNo?: string;
  // 是否是标题行，前端自定义字段
  isTitle?: boolean;

  senderAddress: string;
  recipientAddress?: string;
  bizline?: string; //所属业务线
  itemQuantity?: string; // 小象骑手订单-商品件数
  totalWeight?: string; // 小象骑手订单-总重量
}

export interface IWaiMaiShopDTO {
  // 订单编号，用于PC端
  orderId: string;
  orderTime: string;
  orderType: EnumOrderType;
  orderStatus: string;
  shopName: string;
  shopId: string;
  // 0517 11:00 新增订单序列号，用于B端移动端
  orderSeqNo: string;
  // 是否是标题行，前端自定义字段
  isTitle?: boolean;
  userGetMode: string;
  orderImageUrl?: string;
}

export interface IOrderList {
  hasMore: boolean;
  pageSize: number;
  // 弹窗标题
  popoverTitle: string;
  orderType: EnumOrderType;
  lastOrderId: string;
  orderList: IOrderDTO[];
}

interface IListItem {
  firstFaqName: string;
  secondFaqName: string;
  // 展示名称
  faqDisplayName: string;
  icon?: string;
}

export interface IFaqItem extends IListItem {
  type?: EnumFaqType;
  // 下级查询的key
  faqSearchKey?: string;
  // 是否末节点
  isEndNode: boolean;
  bizline?: string;
  ext?: {
    unreadMsg?: string;
  };
}

export interface IAttachmentDTO {
  uploadPath: string;
  previewImageUrl?: string;
  fileType?: string;
}

export interface ICaseEmailDTO {
  sendTime?: string;
  content?: string;
  sendTimeTs?: number;
  expand?: boolean; // 用来控制展开收起
}

export interface ICreatFormParams {
  description: string;
  faqId: string;
  faqType: string;
  faqSubType: string;
  orderDTO: IOrderDTO | null;
  attachment: IAttachmentDTO[];
  addTime?: string;
  addTimeTs?: number;
  caseEmailDTO?: ICaseEmailDTO;
  caseEmailDTOList?: ICaseEmailDTO[];
  caseId?: string;
  status?: number;
  optScene?: string;
}

export interface IDelyFormDetail {
  order?: IOrderDTO | null;
  caseEmailDTO?: ICaseEmailDTO;
  caseEmailDTOList?: ICaseEmailDTO[];
  attachment?: string[];
  questionDTO?: {
    questionDesc?: string;
    addTime?: string;
    addTimeTs?: number;
  };
  orderFormDTO?: {
    faqType?: string;
    faqSubType?: string;
    faqId?: string;
  };
  optScene?: string;
}

// 工单状态
export enum EnumCaseStatus {
  InProgress = 1, // 进行中
  BeEvaluated = 2, // 待评价
  Deprecated = 3, // 已废弃
  Closed = 4, // 已结案
  Unknown = 999 // 未知
}

// 文件类型
export enum EnumFileType {
  Picture = 'Picture',
  Video = 'Video',
}
export interface IRepeatCase {
  description: string;
  faqId: string;
  faqType: string;
  faqSubType: string;
  orderId: string;
  otherFaqId: string;
  openId: string;
  contactPhone: string;
  contactEmail: string;
  nickNmae: string;
  caseId: string;
  status: number;
  orderDTO: {
    orderType: string;
    orderTitle: string;
    orderTime: string;
    orderPrice: string;
    orderImageUrl: string;
    orderStatus: string;
    userGetMode: string;
    orderId: string;
    orderContentList: string;
    senderAddress: string;
    recipientAddress: string;
    shopName: string;
    shopId: string;
    orderSeqNo: string;
    extend: {
      isShowTranslateButton: boolean;
      cusomerAddressLanguage: string;
      translateAddress: string;
    };
  };
  attachment: {
    uploadPath: string;
    fileType: string;
  }[];
  addTime: string;
  caseEmailDTO: {
    sendTime: string;
    content: string;
  };
}

export interface RiderRedirectParams {
  faqId: number;
  deliveryTaskId: string;
  longitude?: number;
  latitude?: number;
}
